<div>

  <p-table class="prtg-history-table history-table" [value]="entries" [scrollable]="true" scrollHeight="calc(560px)"
    [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn>Device Name</th>
        <th pResizableColumn>IP Address</th>
        <th pResizableColumn>Sensor Name</th>
        <th pResizableColumn>Status</th>
        <th pResizableColumn>Message</th>
        <th pResizableColumn>Timestamp</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.deviceName}}</div>
          </td>
        }
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.ipAddress}}</div>
          </td>
        }
        <td>
          <div class="uv-table-value">{{rowData.sensorName}}</div>
        </td>
        <td  [className]="rowData['style']" pTooltip="{{rowData.status}}">
          <div class="uv-table-value">{{rowData.status}}</div>
        </td>
        <td pTooltip="{{rowData.message}}">
          <div class="uv-table-value">{{rowData.message}}</div>
        </td>
        <td pTooltip="{{formatDateHm(rowData.timestamp)}}">
          <div class="uv-table-value">{{formatDateHm(rowData.timestamp)}}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
